import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import content from '../data/content';

export default function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  const links = [
    { to: '/', label: 'Start' },
    { to: '/#services', label: 'Leistungen', hash: true },
    { to: '/#team', label: 'Team', hash: true },
    { to: '/kontakt', label: 'Kontakt' },
    { to: '/impressum', label: 'Impressum' },
  ];

  const handleClick = (link) => {
    setMobileOpen(false);
    if (link.hash && location.pathname === '/') {
      const el = document.querySelector(link.to.replace('/', ''));
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav className={`navbar ${mobileOpen ? 'mobile-open' : ''}`}>
      <div className="navbar-inner">
        <Link to="/" className="navbar-logo" onClick={() => setMobileOpen(false)}>
          <img src="/images/img-66-332x249.png" alt="Sijelly IT GmbH" />
        </Link>

        <ul className="navbar-links">
          {links.map((link) => (
            <li key={link.to}>
              <Link
                to={link.to}
                onClick={() => handleClick(link)}
                className={location.pathname === link.to ? 'active' : ''}
              >
                {link.label}
              </Link>
            </li>
          ))}
        </ul>

        <div className="navbar-contact">
          <a href={`tel:${content.company.phone}`} className="navbar-contact-item">
            {content.company.phone}
          </a>
          <a href={`mailto:${content.company.email}`} className="navbar-contact-item">
            {content.company.email}
          </a>
          <span className="navbar-contact-item navbar-address">
            {content.company.address}, {content.company.city}
          </span>
        </div>

        <button
          className="navbar-toggle"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="Menü öffnen"
        >
          {mobileOpen ? '✕' : '☰'}
        </button>
      </div>
    </nav>
  );
}
